import React, { useState } from 'react';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { auth, firestore } from '../../utils/firebase-config';
import { TextField, Button, Box, CircularProgress, Alert } from '@mui/material';

const Register = ({ onRegistered, onBack }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      
      // Guardar información adicional en Firestore
      const userDocRef = doc(firestore, 'users', userCredential.user.uid);
      await setDoc(userDocRef, {
        email: email,
        role: 'pendiente_de_asignacion',
        createdAt: new Date()
      });

      setSuccess("Registro exitoso. Ya puedes iniciar sesión.");
      
      if (onRegistered) {
        setTimeout(() => {
            onRegistered();
        }, 1500);
      }
    } catch (error) {
      console.error(error);
      let msg = "Error al registrarse.";
      if (error.code === 'auth/email-already-in-use') msg = "El correo ya está en uso.";
      if (error.code === 'auth/weak-password') msg = "La contraseña es muy débil (mínimo 6 caracteres).";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleRegister} sx={{ mt: 1 }}>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
      
      <TextField
        margin="normal"
        required
        fullWidth
        id="register-email"
        label="Dirección de Email"
        name="email"
        autoComplete="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <TextField
        margin="normal"
        required
        fullWidth
        name="password"
        label="Contraseña"
        type="password"
        id="register-password"
        autoComplete="new-password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        helperText="Mínimo 6 caracteres"
      />
      <Button
        type="submit"
        fullWidth
        variant="contained"
        disabled={loading}
        sx={{ mt: 3, mb: 2 }}
      >
        {loading ? <CircularProgress size={24} /> : "Registrarse"}
      </Button>
    </Box>
  );
};

export default Register;
